// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"8424c33d","231":"ef0daef8"}[chunkId] + ".chunk.js";
};